import { CourseType, SynchronousCourseTypes } from 'enum'
import { CreateNewCourseForm } from './types'
import { ShowDates } from './constants'

export const defaultValues: CreateNewCourseForm = {
  normative: false,
  name: '',
  banner: undefined,
  thumbnail: undefined,
  description: '',
  courseType: CourseType.Open,
  courseTypeSynchronous: SynchronousCourseTypes.external,
  startDate: undefined,
  courseExternal: '',
  untilDate: undefined,
  optionalProfiles: [],
  requiredProfiles: [],
  state: undefined,
  showDates: ShowDates.inactive,
  invitationNotification: null,
  enrolCreatedNotification: null,
  lessons: [],
  hasStarted: false,
  canGenerateCertificate: false,
  reminderNotification: undefined,
  courseSynchronousProperties: {},
  courseSynchronous: false,
  hours: '',
  canRestart: false,
}

export const defaultErrors = {
  name: '',
  description: '',
  hours: '',
  banner: '',
  thumbnail: '',
  courseType: '',
  startDate: '',
  untilDate: '',
  optionalProfiles: '',
  requiredProfiles: '',
  state: '',
  sendEmail: '',
  invitationNotification: '',
  lessons: '',
  hasStarted: '',
}
